module.exports = __webpack_public_path__ + "static/img/FMF.416a6c03.png";